import styled from "styled-components";

export const Styles = styled.span`
  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "標準";
  }

  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]:before {
    content: "特大";
  }

  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]:before {
    content: "大";
  }

  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before,
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]:before {
    content: "中";
  }

  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    content: "保存";
  }
  .ql-snow .ql-tooltip::before {
    display: none;
  }

  .ql-clipboard {
    position: fixed !important;
    left: 50% !important;
    top: 50% !important;
  }
  .ql-tooltip.ql-editing {
    left: 0px !important;
    top: auto !important;
    transform: translateX(0);
  }

  .ql-toolbar.ql-snow {
    padding: 2px 8px;
  }

  .ql-snow .ql-tooltip a.ql-action::after {
    content: "編集";
  }

  .ql-snow .ql-tooltip a.ql-remove::before {
    content: "削除";
  }

  .ql-tooltip {
    left: 0;
    z-index: 16;
    .add-name-url-container {
      display: none;
    }
  }
  .ql-tooltip.ql-editing {
    .add-name-url-container {
      margin-bottom: 3px;
      display: block;
    }
  }
  .ql-snow .ql-tooltip[data-mode="link"]::before {
    display: none;
  }

  &:not(.show-tooltip-preview) {
    .ql-remove {
      display: none;
    }
    .ql-snow .ql-tooltip a.ql-action::after {
      border-right: none;
      display: none;
    }
  }
  .ql-tooltip.ql-editing {
    .ql-action {
      display: none;
    }
    .button-save-link {
      display: inline-block;
    }
  }
  .label-url {
    padding-right: 16px;
  }
  .label-name-url {
    padding-right: 2px;
  }
  .button-save-link {
    padding-left: 10px;
    color: #06c;
    display: none;
    &:hover {
      color: #40a9ff;
    }
  }
  &.hidden-toolbar {
    .ql-toolbar.ql-snow {
      display: none;
    }
    .ql-container.ql-disabled {
      border: 1px solid #ccc;
    }
  }
`;
